(() => {
  if (customElements.get('godness-gallery')) return;

  class GodnessGallery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.controls = this.querySelector('[data-gallery-controls]');
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.status = this.querySelector('[data-gallery-status]');
      if (!this.track || this.slides.length < 2 || !this.controls || !this.previous || !this.next || !this.status) return;

      this.index = 0;
      this.frame = 0;
      this.onPrevious = () => this.goTo(this.index - 1);
      this.onNext = () => this.goTo(this.index + 1);
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = 0;
          this.update();
        });
      };
      this.onKey = (event) => {
        if (event.target !== this.track) return;
        const destinations = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!Object.prototype.hasOwnProperty.call(destinations, event.key)) return;
        event.preventDefault();
        this.goTo(destinations[event.key]);
      };
      this.onResize = () => {
        this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'auto' });
        this.update();
      };

      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('keydown', this.onKey);
      this.previous.addEventListener('click', this.onPrevious);
      this.next.addEventListener('click', this.onNext);
      if ('ResizeObserver' in window) {
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.track);
      } else {
        window.addEventListener('resize', this.onResize);
      }
      this.initialized = true;
      this.controls.hidden = false;
      this.update();
    }

    goTo(index) {
      const target = Math.max(0, Math.min(index, this.slides.length - 1));
      this.track.scrollTo({
        left: target * this.track.clientWidth,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }

    update() {
      if (!this.track.clientWidth) return;
      this.index = Math.max(0, Math.min(Math.round(this.track.scrollLeft / this.track.clientWidth), this.slides.length - 1));
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      const label = `${this.index + 1} / ${this.slides.length}`;
      if (this.status.textContent !== label) this.status.textContent = label;
    }

    disconnectedCallback() {
      if (!this.initialized) return;
      this.track.removeEventListener('scroll', this.onScroll);
      this.track.removeEventListener('keydown', this.onKey);
      this.previous.removeEventListener('click', this.onPrevious);
      this.next.removeEventListener('click', this.onNext);
      window.removeEventListener('resize', this.onResize);
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.controls.hidden = true;
      this.initialized = false;
    }
  }

  customElements.define('godness-gallery', GodnessGallery);
})();
